import { UseDoResetPasswordSendCodeMutationContextProvider } from '@/transport/components/UseDoResetPasswordSendCodeMutationContextProvider';
import { FC, Suspense } from 'react';
import { IFaceLoader } from '@/bo-kit/components';
import { UseDoResetPasswordMutationContextProvider } from '@/transport/components/UseDoResetPasswordMutationContextProvider';
import ResetPasswordCodeVerifyPageResponsive from '@/bo-kit/components/ResetPasswordPage/components/CodeVerify';

export const ResetPasswordCodePage: FC = () => (
    <UseDoResetPasswordMutationContextProvider>
        <UseDoResetPasswordSendCodeMutationContextProvider>
            <Suspense fallback={<IFaceLoader />}>
                <ResetPasswordCodeVerifyPageResponsive implementation='js' />
            </Suspense>
        </UseDoResetPasswordSendCodeMutationContextProvider>
    </UseDoResetPasswordMutationContextProvider>
);
